// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__grl3b","title":"Images90_title__Z2M_Y","images":"Images90_images__3vrE3"};